export const NO_TRACKING_ROUTES = new Set([
  "/allgemeine-geschaeftsbedingungen",
  "/datenschutzerklaerung",
]);

export const COOKIE_CONSENT_SUPPRESSED_ROUTES = new Set([
  "/magic-link-app",
]);

export function normalizePathname(pathname = "") {
  if (!pathname || pathname === "/") return "/";
  return pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
}

export function isNoTrackingRoute(pathname = "") {
  return NO_TRACKING_ROUTES.has(normalizePathname(pathname));
}

export function isCookieConsentSuppressedRoute(pathname = "") {
  const normalizedPathname = normalizePathname(pathname);
  return (
    isNoTrackingRoute(normalizedPathname) ||
    COOKIE_CONSENT_SUPPRESSED_ROUTES.has(normalizedPathname)
  );
}
